import {
  FileVisibility,
  TokenizeFileRequestBody,
  TokenizeFileResponseBody,
} from 'bff'
import { useCallback, useState } from 'react'

export const useFileUpload = ({
  tokenizeFile,
  visibility = 'private',
}: {
  visibility: FileVisibility
  tokenizeFile: (input: {
    body: TokenizeFileRequestBody
  }) => Promise<TokenizeFileResponseBody>
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [name, setName] = useState('')

  const handleFileUpload = useCallback(
    (callback: (token: string, url: string) => void) => {
      return async (file: File) => {
        setIsLoading(true)

        const { fields, presigned_url, fetch_url, token } = await tokenizeFile({
          body: {
            name: file!.name,
            size: file!.size,
            visibility,
          },
        })

        const formData = new FormData()

        for (const key in fields) {
          const value = fields[key as keyof typeof fields]

          formData.append(key, value)
        }

        formData.append('file', file!)

        await fetch(presigned_url, {
          method: 'POST',
          body: formData,
        })

        callback(token, fetch_url)

        setIsLoading(false)
        setName(file.name)
      }
    },
    []
  )

  return {
    handleFileUpload,
    isLoading,
    name,
  }
}
